import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useMemo } from 'react';
import { catById, computeBalances, effAmt, monthEndStr, todayStr } from '@/utils';
import MonthPanel from '@/modules/calendar/month-panel';
import YearMonthCell from '@/modules/calendar/year-month-cell';
import style from './style.module.scss';
//TODO: simplify props for year-month-cell.
function YearView({ budget, year, dispatch, onAddTx }) {
    const [selMonth, setSelMonth] = useState(null);
    const curYear = new Date().getFullYear();
    const curMonth = new Date().getMonth();
    const months = useMemo(() => Array.from({ length: 12 }, (_, m) => {
        const me = monthEndStr(year, m);
        const ms = `${year}-${String(m + 1).padStart(2, '0')}-01`;
        const txs = budget.transactions.filter((tx) => tx.date >= ms && tx.date <= me);
        const bal = computeBalances(budget, year, m);
        const catVol = {};
        txs.forEach((tx) => {
            const e = effAmt(tx);
            if (!e)
                return;
            const key = tx.category || 'other';
            if (!catVol[key])
                catVol[key] = { exp: 0, inc: 0 };
            if (tx.type === 'expense')
                catVol[key].exp += e;
            else
                catVol[key].inc += e;
        });
        const topCats = Object.entries(catVol)
            .sort((a, b) => b[1].exp + b[1].inc - (a[1].exp + a[1].inc))
            .slice(0, 3)
            .map(([id, v]) => ({
            cat: catById(budget, id) || { id, label: id, icon: '📦', type: 'expense' },
            ...v,
        }));
        return { m, endBal: bal[me], topCats, txCount: txs.length };
    }), [budget, year]);
    return (_jsxs("div", { className: style["year-container"], children: [_jsx("div", { className: style["year-wrapper"], children: _jsx("div", { className: style["year-grid"], children: months.map(({ m, endBal, topCats, txCount }) => {
                        const isCur = year === curYear && m === curMonth;
                        const isSel = selMonth === m;
                        return (_jsx(YearMonthCell, { m: m, year: year, isCur: isCur, isSel: isSel, endBal: endBal, topCats: topCats, txCount: txCount, currency: budget.currency, onSelect: () => setSelMonth((sm) => (sm === m ? null : m)), onAddTx: () => {
                                const ms = `${year}-${String(m + 1).padStart(2, '0')}-01`;
                                onAddTx(year === curYear && m === curMonth ? todayStr() : ms);
                            } }, m));
                    }) }) }), selMonth !== null && (
            // <div className="side-panel">
            _jsx(MonthPanel, { budget: budget, year: year, month: selMonth, onClose: () => setSelMonth(null), onGoMonth: () => dispatch({ type: 'GO_MONTH', year, month: selMonth }), onAddTx: () => {
                    const ms = `${year}-${String(selMonth + 1).padStart(2, '0')}-01`;
                    onAddTx(year === curYear && selMonth === curMonth ? todayStr() : ms);
                } })
            // </div>
            )] }));
}
// interface YearMonthCellProps {
//   m: number;
//   year: number;
//   curYear: number;
//   curMonth: number;
//   isCur: boolean;
//   isSel: boolean;
//   endBal?: number;
//   topCats: { cat: { id: string; label: string; icon: string }; exp: number; inc: number }[];
//   txCount: number;
//   currency: string;
//   onSelect: () => void;
//   onAddTx: () => void;
// }
// function YearMonthCell({ m, isCur, isSel, endBal, topCats, txCount, currency, onSelect, onAddTx }: YearMonthCellProps) {
//   const handler = useClickDouble(useCallback(onSelect, [onSelect]), useCallback(onAddTx, [onAddTx]));
//   return (
//     <div className={`ymc${isCur ? ' cur' : ''}${isSel ? ' sel' : ''}`} onClick={handler}>
//       <div className="ymc-top">
//         <div className="ymc-name">{MONTHS[m]}</div>
//         {endBal !== undefined && <div className={`ymc-bal${endBal < 0 ? ' neg' : ''}`}>{fmt(endBal, currency)}</div>}
//       </div>
//       <div className="ymc-cats">
//         {topCats.length === 0 ? (
//           <span className="ymc-empty">Нет операций</span>
//         ) : topCats.map(({ cat, exp, inc }) => (
//           <div key={cat.id} className="ymc-cat">
//             <div className="ymc-cat-left">
//               <span>{cat.icon}</span>
//               <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{cat.label}</span>
//             </div>
//             <span className="ymc-cat-amt">
//               {exp > 0 && <span style={{ color: 'var(--expense)' }}>−{fmt(exp, currency)}</span>}
//               {inc > 0 && <span style={{ color: 'var(--income)', marginLeft: 2 }}>+{fmt(inc, currency)}</span>}
//             </span>
//           </div>
//         ))}
//       </div>
//       {txCount > 0 && <div className="ymc-count">{txCount} операций</div>}
//     </div>
//   );
// }
export default YearView;
